class SalaryBand {
	async getEmployees(company_id, queryString) {
		const response = await fetch(`${process.env.REACT_APP_API}/salary/salary-benefits/${company_id}?${queryString}`)

		return await response.json()
	}

	async getReportDataEmployee(employeeId) {
		const response = await fetch(`${process.env.REACT_APP_API}/salary/salary-benefits-report/${employeeId}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return await response.json()
	}

	async getReportEmployee(urlData) {
		const response = await fetch(
			`https://smtm.co/report?city_id=${urlData.cityId}&country_id=${urlData.countryId}&job_id=${urlData.jobId}&current_salary_aux=${
				urlData.currentSalary
			}&variable_salaries=${parseInt(urlData.variable)}&industry_id=${urlData.industryId}&english_level_id=${
				urlData.englishLevelId
			}&company_size_id=${urlData.companySizeId}&seniority_id=${urlData.seniorityId}&qualification_id=${urlData.qualificationId}&country_code=${
				urlData.countryCode
			}&locale=${
				urlData.locale
			}&payment_method=webpay&report_type=company&people_report=false&trans_areas=%C3%81rea%20de%20actuaci%C3%B3n&trans_jobs=Posici%C3%B3n&company_size_id_aux=${
				urlData.companySizeId
			}&current_salary=${urlData.currentSalary}&area_id=${urlData.areaId}&language=native&reportfrom=${
				urlData.reportFrom
			}&job_fantasia=${encodeURIComponent(urlData.jobFantasia.trim())}&area_fantasia=${encodeURIComponent(urlData.areaFantasia.trim())}`,
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(urlData.bodyReport),
			}
		)
		return await response.json()
	}

	async createSalaryCompany(data) {
		const response = await fetch(`${process.env.REACT_APP_API}/salarycompanybylevel/`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		})
		return await response.json()
	}

	async updateSalaryCompany(id, data) {
		const response = await fetch(`${process.env.REACT_APP_API}/salarycompanybylevel/${id}`, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		})
		return await response.json()
	}

	async dataToExcel(companyId) {
		const response = await fetch(`${process.env.REACT_APP_API}/salary/employee-list-to-excel/${companyId}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})

		return response.json()
	}
}
export default new SalaryBand()
